import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ProfileSetup.ProfileSetupForm', {
    profileSetupTitle: "Let's get you set up",
    signupButtonText: 'Complete sign up',
    signupConsentText:
        'By clicking "{buttonText}", you agree to our <terms>Terms and Conditions</terms> and <policy>Privacy Policy</policy>',
    fieldFirstNamePlaceholder: 'Enter first name...',
    fieldLastNamePlaceholder: 'Enter last name...',
    fieldPasswordPlaceholder: 'Password',
    fieldPhonePlaceholder: 'Enter phone...',
    fieldPhoneTooltip: 'We need your phone number to enable security measures and associated communications.',
    qualificationQuestionsAnswersIsInvalid: 'Please complete all the fields in the form',
    consentMarketingText: "I agree to receive ApprovalMax's news, insights and special offers",
    ssoPanelCaption: 'or continue with one of the options',

    errorFirstNameRequired: 'Enter a first name',
    errorLastNameRequired: 'Enter a last name',
    errorPasswordRequired: 'Password is required',
    errorPasswordInvalid: 'Password does not meet the requirements',
    errorPhoneRequired: 'Phone number is required',
    errorPhoneInvalid: 'Phone number is invalid, please check that it has been entered properly.',
    errorTypeOfBusinessRequired: 'Type of business required',
    errorPartnerStatus: 'Select partner status',
    errorPartnerSegment: 'Select partner segment',
    errorNumberOfClients: 'Select number of clients',
    errorProductInterest: 'Select product interest',
    errorNumberOfEntities: 'Select number of entities',
    errorUseCase: 'Select use case',
    errorBusinessSegment: 'Select business segment',
});
